<template>
    <div class="header_main">
        <Logo></Logo>
        <div v-if="renderDevice === 'desktop'" class="flex-row h-full d-flex">
            <div
                v-for="(menu, index) in getlistMenu()"
                :key="index"
                :class="[
                    'text-primary cursor-pointer h-full d-flex px-[27px]',
                    $route.path === menu.path ? 'bg-[#E3EEFF]' : '',
                ]"
                @click="changeToLink(menu)"
            >
                <span class="m-auto !font-bold text-content-1">{{ menu.name }}</span>
            </div>
        </div>
        <WrapMenu>
            <div v-if="renderDevice === 'mobile'" class="flex-row d-flex">
                <div
                    v-for="(menu, index) in getlistMenu()"
                    :key="index"
                    :class="[
                        'text-primary cursor-pointer items-start h-[48px] flex pl-[56px] py-4',
                        $route.path === menu.path ? 'bg-[#E3EEFF]' : '',
                    ]"
                    @click="changeToLink(menu)"
                >
                    <span class="my-auto !font-bold text-content-1">{{ menu.name }}</span>
                </div>
            </div>
            <div style="display: flex;" class="flex-row items-center gap-4 mobile:flex-col tablet:flex-col">
                <Language />
                <div
                    v-if="loginSuccess"
                    style="display: flex"
                    class="items-center justify-center gap-5 d-flex mobile:flex-col tablet:flex-col"
                >
                    <div>
                        <div
                            v-if="walletConnected.walletAddress"
                            @click="openWalletModal"
                            class="items-center justify-between cursor-pointer d-flex"
                            style="
                                border-radius: 30px;
                                border: 1px solid #a3c2ff;
                                padding: 10px 30px;
                                color: #1a5bda;
                            "
                        >
                            {{
                                walletConnected.walletAddress.slice(0, 6) +
                                '...' +
                                walletConnected.walletAddress.slice(
                                    walletConnected.walletAddress.length - 3,
                                )
                            }}
                        </div>
                        <div
                            v-else
                            @click="openWalletModal"
                            class="items-center justify-between text-center cursor-pointer d-flex"
                            style="
                                border-radius: 30px;
                                border: 1px solid #a3c2ff;
                                padding: 10px 30px;
                                color: #1a5bda;
                            "
                        >
                            {{ $t('home.newFeatures.common.connect') }}
                        </div>
                    </div>
                    <div>
                        <div
                            class="flex w-12 h-12 rounded-full cursor-pointer bg-secondary"
                            @click="openWallet"
                            v-if="loginSuccess"
                        >
                            <img
                                class="m-auto h-[32px] w-[24px]"
                                src="@/assets/icons/icon-wallet.svg"
                            />
                        </div>
                        <a-modal
                            wrapClassName="modal_token_wallet"
                            centered
                            v-model="isopenWallet"
                            :title="$t('home.homePage.walletTitle')"
                        >
                            <div
                                v-if="isopenWallet"
                                :class="[
                                    { connectionMeta: walletConnected.walletAddress },
                                ]"
                            >
                                <div>
                                    <img
                                        v-if="isloadWallet || iswithdrawWallet"
                                        @click="backWallet"
                                        class="img-back"
                                        src="@/assets/icons/back-wallet.svg"
                                        alt=""
                                    />
                                    <div v-if="!isloadWallet && !iswithdrawWallet">
                                        <div
                                            class="flex flex-row items-center justify-between mb-6"
                                        >
                                            <p
                                                class="font-bold text-primary text-content-1"
                                            >
                                                {{ $t('home.homePage.walletBalance') }}
                                            </p>
                                            <div>
                                                <img
                                                    :class="[
                                                        {
                                                            reload_animation:
                                                                isLoadingBalance,
                                                        },
                                                        'cursor-pointer',
                                                    ]"
                                                    @click="reloadWallet"
                                                    src="@/assets/icons/load.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            class="flex flex-col gap-4 list_token_wallet"
                                        >
                                            <div
                                                class="flex flex-row items-center justify-between"
                                                v-for="item in LIST_TOKEN_WALLET"
                                                :key="item.symbol"
                                            >
                                                <div
                                                    class="flex flex-row items-center gap-3 font-bold"
                                                >
                                                    <img
                                                        class="w-8"
                                                        :src="item.logo"
                                                        alt="logo"
                                                    />
                                                    <span
                                                        class="font-bold text-primary text-content-1"
                                                        >{{ item.symbol }}</span
                                                    >
                                                </div>
                                                <h4>{{ findBalance(item.symbol) }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isloadWallet" class="load-wallet-block">
                                        <h4>{{ $t('home.homePage.loadWalletTitle') }}</h4>
                                        <div class="load-wallet-block-content">
                                            {{ $t('home.homePage.loadWalletContent') }}
                                        </div>
                                        <div class="load-wallet-block-subcontent">
                                            {{ $t('home.homePage.loadWalletSubContent') }}
                                        </div>
                                        <div class="load-wallet-block-label">
                                            {{ $t('home.homePage.walletAddress') }}
                                        </div>
                                        <div class="input-wallet-address">
                                            <CommonTextInputGroup
                                                :readonly="true"
                                                :value="userLogined.wallet.eth_address"
                                                :placeholder="$t('layout.common.email')"
                                                class="mt-6 text-left"
                                                name="email"
                                                autocomplete="on"
                                            >
                                                <template slot="image">
                                                    <img
                                                        @click="
                                                            copyWallet(
                                                                userLogined.wallet
                                                                    .eth_address,
                                                            )
                                                        "
                                                        class="input-wallet-address-copy"
                                                        src="@/assets/icons/copy.svg"
                                                        alt=""
                                                    />
                                                </template>
                                            </CommonTextInputGroup>
                                        </div>
                                        <div class="load-wallet-block-content3">
                                            {{ $t('home.homePage.scanAddress') }}
                                        </div>
                                        <div class="block-qr">
                                            <qrcode-vue
                                                :value="
                                                    'ethereum:' +
                                                    userLogined.wallet.eth_address
                                                "
                                                :size="200"
                                                background="#fff"
                                                render-as="svg"
                                            ></qrcode-vue>
                                        </div>
                                        <CommonPrimaryButton
                                            :text="$t('home.homePage.okie')"
                                            @click="closeWallet"
                                            class="button"
                                        />
                                    </div>
                                    <div
                                        v-if="iswithdrawWallet"
                                        class="load-wallet-block"
                                    >
                                        <h3 style="margin-top: 3rem">
                                            {{ $t('home.homePage.commonSoon') }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </a-modal>
                    </div>
                    <a-dropdown :trigger="['click']">
                        <div
                            class="flex w-12 h-12 rounded-full cursor-pointer bg-secondary"
                        >
                            <img class="m-auto" src="@/assets/icons/icon-user.svg" />
                        </div>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item>
                                    <div
                                        class="!w-full flex text-[#0f8cc5] font-bold w-fit cursor-pointer p-2 px-4"
                                    >
                                        <p class="rounded-lg !text-primary !mb-0">
                                            {{ splitEmail(userLogined.email) }}
                                        </p>
                                    </div>
                                </a-menu-item>
                                <a-menu-item>
                                    <div
                                        class="px-4 py-2 v-list-item__title"
                                        @click="directTransaction()"
                                    >
                                        <img
                                            src="@/assets/icons/icon-transaction-menu.svg"
                                            class="icon"
                                        />

                                        <span>{{
                                            $t(
                                                'home.newFeatures.transaction.transaction_history',
                                            )
                                        }}</span>
                                    </div>
                                </a-menu-item>
                                <a-menu-item>
                                    <div
                                        class="px-4 py-2 v-list-item__title"
                                        @click="goToChangePass"
                                    >
                                        <img
                                            src="@/assets/icons/icon-lock.svg"
                                            class="icon"
                                        />

                                        <span>{{ $t('home.homePage.changePass') }}</span>
                                    </div>
                                </a-menu-item>
                                <a-menu-item>
                                    <div
                                        class="px-4 py-2 v-list-item__title"
                                        @click="logOut"
                                    >
                                        <img
                                            src="@/assets/icons/icon-log-out.svg"
                                            class="icon"
                                        />
                                        <span>{{ $t('home.homePage.logOut') }}</span>
                                    </div>
                                </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </div>
                <div v-if="!loginSuccess" class="flex flex-col desktop:!flex-row gap-4 px-3 mobile:w-full tablet:w-full">
                    <div class="button__auth text-content-1" @click="login">
                        {{ $t('auth.login.buttonLogin') }}
                    </div>
                    <div class="button__auth text-content-1" @click="register">
                        {{ $t('auth.register.buttonRegister') }}
                    </div>
                </div>
            </div>
        </WrapMenu>
        <a-modal
            wrapClassName="modal_connect_wallet"
            centered
            v-if="loginSuccess"
            v-model="dialogWallet"
            :title="$t('home.homePage.walletTitle')"
        >
            <div v-if="loginSuccess" class="flex flex-col gap-6">
                <BlockWallet
                    class="flex flex-row items-center justify-between"
                    v-if="
                        !walletConnected.connectedWallet ||
                        walletConnected.wallet === 'metamask'
                    "
                >
                    <CommonTertiaryButton
                        v-if="!walletConnected.connectedWallet"
                        :text="$t('home.newFeatures.common.connect')"
                        @click="detectDeviceMetamask"
                        class="button-connect"
                    />
                    <div class="wallet-address" v-else>
                        <span>{{ shortWalletAddress }}</span>
                    </div>
                </BlockWallet>
                <BlockWallet
                    class="flex flex-row items-center justify-between"
                    v-if="
                        !walletConnected.connectedWallet ||
                        walletConnected.wallet === 'wallet_connect'
                    "
                    title="WalletConnect"
                    :icon="require('@/assets/icons/walletconnect.svg')"
                >
                    <CommonTertiaryButton
                        v-if="!walletConnected.connectedWallet"
                        :text="$t('home.newFeatures.common.connect')"
                        @click="initWalletConnect"
                        class="button-connect"
                    />
                    <div v-else class="wallet-address">
                        <span>{{ shortWalletAddress }}</span>
                    </div>
                </BlockWallet>
                <CommonTertiaryButton
                    v-if="walletConnected.connectedWallet"
                    text="Disconnect"
                    @click="disconnectWallet"
                    class="button-connect space-mobile"
                />
            </div>
        </a-modal>
    </div>
</template>
<script>
import { Watch } from 'vue-property-decorator';
import Language from '@/components/LanguageTabs.vue';
import i18n from '@/plugins/i18n';
import ButtonImageBefore from '@/components/button/ButtonImageBefore.vue';
import ButtonImage from '@/components/button/ButtonImage.vue';
import bus from '@/helpers/bus';
import DeviceDetector from 'device-detector-js';
import BlockWallet from '@/modules/common/components/BlockWallet.vue';
import { Web3Mixin } from '@/mixins/Web3Mixin';
import Component from 'vue-class-component';
import QrcodeVue from 'qrcode.vue';
import Logo from '@/modules/auth/components/logo/logo.vue';
import WrapMenu from './WrapMenu.vue';

@Component({
    components: {
        ButtonImage,
        WrapMenu,
        Logo,
        ButtonImageBefore,
        Language,
        BlockWallet,
        QrcodeVue,
    },
})
export default class MenuComponent extends Web3Mixin {
    isLoadingBalance = false;
    isopenWallet = false;
    isloadWallet = false;
    iswithdrawWallet = false;
    address = this.getCookie('metamask');
    isShowMenuMobile = false;
    isDesktop = true;
    isFoldOpen = false;

    drawer = true;

    get renderDevice() {
        if (window.innerWidth > 1024) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }
    get dialogWallet() {
        return this.$store.state.dialogWallet;
    }

    set dialogWallet(value) {
        this.$store.commit('SET_SHOW_DIALOG_WALLET', value);
    }

    get walletConnected() {
        return this.$store.state.walletConnected;
    }

    get shortWalletAddress() {
        return (
            this.walletConnected.walletAddress.substr(0, 2) +
            '...' +
            this.walletConnected.walletAddress.substr(
                this.walletConnected.walletAddress.length - 4,
            )
        );
    }

    get reCallApi() {
        return this.$store.state.home.reCallApi;
    }

    LIST_TOKEN_WALLET = [
        {
            symbol: 'AIS',
            logo: require('@/assets/icons/logo-ais.png'),
        },
        {
            symbol: 'SBG',
            logo: require('@/assets/icons/sbg-icon.png'),
        },
        {
            symbol: 'USDT',
            logo: require('@/assets/icons/logo-usdt.png'),
        },
        {
            symbol: 'BNB',
            logo: require('@/assets/icons/logo-bnb.png'),
        },
        {
          symbol: 'STN-A',
          logo: require('@/assets/icons/stn-a.png'),
        },
    ];

    LIST_TOKEN = [
        {
            logo: '@/assets/icons/logo-ais.png',
            symbol: 'AIS',
        },
        {
            logo: '@/assets/icons/sbg-icon.png',
            symbol: 'SBG',
        },
        {
            logo: '@/assets/icons/logo-usdt.png',
            symbol: 'USDT',
        },
        {
            logo: '@/assets/icons/logo-bnb.png',
            symbol: 'BNB',
        },
    ];

    @Watch('reCallApi')
    async fetchData() {
        if (this.reCallApi) {
            await this.reloadWallet();
            this.$store.commit('home/SET_RECALL_API', false);
        }
    }

    created() {
        bus.$on('change-language', this.changeLanguage);
    }

    beforeDestroy() {
        bus.$off('change-language');
    }

    openWalletModal() {
        this.$store.commit('SET_SHOW_DIALOG_WALLET', true);
    }

    changeLanguage() {
        this.isShowMenuMobile = false;
    }

    openWallet() {
        this.isopenWallet = !this.isopenWallet;
        this.isloadWallet = false;
        this.iswithdrawWallet = false;
    }

    closeWallet() {
        this.isopenWallet = false;
        this.isloadWallet = false;
        this.iswithdrawWallet = false;
    }

    backWallet() {
        this.isopenWallet = true;
        this.isloadWallet = false;
        this.iswithdrawWallet = false;
    }

    copyWallet(text) {
        navigator.clipboard.writeText(text);
        this.$store.dispatch('setCommonMessage', i18n.t('home.homePage.copyAddress'));
    }

    loadWallet() {
        this.isloadWallet = true;
        this.iswithdrawWallet = false;
    }

    withdrawWallet() {
        this.isloadWallet = false;
        this.iswithdrawWallet = true;
    }

    async mounted() {
        if (this.typeDevice === 'desktop') {
            this.isDesktop = true;
            this.isFoldOpen = false;
        } else {
            this.isDesktop = false;
            this.isFoldOpen = screen.width > 700;
        }
    }

    splitEmail(email) {
        let arr = email?.split('@') || [];
        let name = `${arr[0]}`.substring(0, 3);
        let mail = `${name}...` + '@' + arr[1];
        return mail;
    }

    clickOutSide() {
        this.isShowMenuMobile = false;
    }

    getlistMenu() {
        let listMenu = [
            { id: 2, path: '/collection', name: this.$t('layout.common.collection') },
            { id: 1, path: '/', name: this.$t('layout.common.home') },
            {
                id: 4,
                path: '',
                name: this.$t('layout.common.nft_intro'),
                redirectLink: 'https://nft.aispa.io/#/home',
            },
            {
                id: 3,
                path: '',
                name: this.$t('layout.common.about_us'),
                redirectLink: 'https://aispa.io/',
            },

            // { id: 3, path: '/history', name: this.$t('home.homePage.history_title') },
            // { id: 4, path: '/collaborators', name: this.$t('home.homePage.collaborators_title') },
            // { id: 3, path: '/faq', name: this.$t('layout.common.faq') },
        ];
        if (!this.loginSuccess) {
            listMenu = [
                { id: 1, path: '/', name: this.$t('layout.common.home') },
                {
                    id: 3,
                    path: '',
                    name: this.$t('layout.common.nft_intro'),
                    redirectLink: 'https://nft.aispa.io/#/home',
                },
                {
                    id: 2,
                    path: '',
                    name: this.$t('layout.common.about_us'),
                    redirectLink: 'https://aispa.io/',
                },
                // { id: 3, path: '/history', name: this.$t('home.homePage.history_title') },
                // { id: 4, path: '/collaborators', name: this.$t('home.homePage.collaborators_title') },
                // { id: 3, path: '/faq', name: this.$t('layout.common.faq') },
            ];
        }
        return listMenu;
    }

    clickCollaborators(menu) {
        if (this.userLogined && this.userLogined.collaborator) {
            this.changeToLink(menu);
        } else {
            this.$swal
                .fire({
                    customClass: {
                        popup: 'swal-collaborators',
                    },
                    width: '421px',
                    showCancelButton: true,
                    title: `${i18n.t('collaborators.collaborators.register_title')}`,
                    text: `${i18n.t('collaborators.collaborators.register_content')}`,
                    confirmButtonText: `${i18n.t(
                        'collaborators.collaborators.confirm_register',
                    )}`,
                    cancelButtonText: `${i18n.t(
                        'collaborators.collaborators.close_register',
                    )}`,
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        await this.$store.dispatch('setLoadingIndicator', true, {
                            root: true,
                        });
                        const res = await this.$store.dispatch(
                            'collaborators/createCollaboratorsApi',
                        );
                        if (res.status_code == 200) {
                            this.changeToLink({ path: '/collaborators' });
                        } else {
                            await this.$swal.fire({
                                customClass: {
                                    popup: 'swal-key-status-rejected',
                                },
                                title: `${i18n.t('collaborators.collaborators.oops')}`,
                                text: res.message
                                    ? res.message
                                    : `${i18n.t(
                                          'collaborators.collaborators.unknown_error',
                                      )}`,
                                confirmButtonText: `${i18n.t(
                                    'collaborators.collaborators.ok',
                                )}`,
                            });
                        }
                        await this.$store.dispatch('setLoadingIndicator', false, {
                            root: true,
                        });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }

    get messageTooltip() {
        return `${i18n.t('layout.common.accountApprovedTooltip')}`;
    }

    get getUrlIcon() {
        return require('@/assets/icons/icon-success.svg');
    }

    findBalance(symbol) {
        return this.userLogined.tokens &&
            this.userLogined.tokens.find((item) => item.symbol === symbol)
            ? this.userLogined.tokens.find((item) => item.symbol === symbol).balance
            : 0;
    }

    reloadWallet() {
        this.isLoadingBalance = true;
        setTimeout(async () => {
            this.isLoadingBalance = false;
            await this.$store.dispatch('auth/getMe');
        }, 1000);
    }

    async initWalletConnect() {
        await this.initProviderWalletConnect();
        if (this.provider !== null) {
            await this.initWeb3();
            await this.checkConnected();
        }
    }

    connectMetamaskMobile() {
        const dappUrl = window.location.href.split('//')[1].split('/')[0];
        const appDeepLink = 'https://metamask.app.link/dapp/' + dappUrl;
        window.open(appDeepLink, '_self');
    }

    connectTrustMobile() {
        const dappUrl = window.location.href.split('//')[1].split('/')[0];
        const appDeepLink = 'https://link.trustwallet.com/' + dappUrl;
        window.open(appDeepLink, '_self');
    }

    detectDeviceMetamask() {
        if (
            !navigator.userAgent.includes('WebView MetaMaskMobile') &&
            ['phablet', 'smartphone', 'tablet'].includes(this.typeDevice)
        ) {
            this.connectMetamaskMobile();
        } else {
            this.initLoginMetamask();
        }
    }

    detectDeviceTrust() {
        if (
            !navigator.userAgent.includes('WebView MetaMaskMobile') &&
            ['phablet', 'smartphone', 'tablet'].includes(this.typeDevice)
        ) {
            this.connectTrustMobile();
        } else {
            this.initLoginMetamask(true);
        }
    }

    async initLoginMetamask(isTrustWallet = false) {
        try {
            this.$store.commit('SET_PROVIDER', null);
            // check install metamask
            if (
                !window.ethereum &&
                !['phablet', 'smartphone', 'tablet'].includes(this.typeDevice)
            ) {
                await this.$swal
                    .fire({
                        customClass: {
                            popup: 'swal-container-no-image',
                        },
                        title: `${i18n.t('home.homePage.message.titleConnectWallet')}`,
                        text: `Check install and log in wallet`,
                        confirmButtonText: `${i18n.t('home.homePage.ok')}`,
                    })
                    .then((result) => {
                        window.open('https://metamask.io/download/');
                    });
                return;
            }
            if (isTrustWallet) {
                await this.initTrustWalletProvider();
            } else {
                await this.initMetamaskProvider();
            }
            this.initWeb3();
            await this.provider.send('eth_requestAccounts');
            const coinbase = await this.web3.eth.getCoinbase();
            if (Array.isArray(coinbase)) {
                if (coinbase.length === 0) {
                    this.$store.dispatch(
                        'setCommonMessage',
                        this.$t('Check install and log in wallet'),
                    );
                }
            } else if (!coinbase) {
                this.$store.dispatch(
                    'setCommonMessage',
                    this.$t('Check install and log in wallet'),
                );
            }
            await this.checkConnected();

            await this.$store.dispatch('home/metamask', { address: this.walletAddress });

            this.$store.dispatch(
                'setCommonMessage',
                this.$t('layout.common.successConnection'),
            );
            this.$store.commit(
                'auth/SET_NOTIFYSUCCESS',
                this.$t('layout.common.successConnection'),
            );
        } catch (e) {
            this.setCookie('metamask', '');
            if (e.code === 4001) {
                return;
            }
            await this.$swal.fire({
                customClass: {
                    popup: 'swal-container-no-image',
                },
                title: `${i18n.t('home.homePage.message.titleConnectWallet')}`,
                text:
                    e.code === -32002
                        ? `${i18n.t('home.homePage.message.opened')}`
                        : `${i18n.t('home.homePage.message.connectFail')}`,
                confirmButtonText: `${i18n.t('home.homePage.ok')}`,
            });
            return;
        }
    }

    goToChangePass() {
        this.isShowMenuMobile = false;
        this.$router.push({ name: 'ChangePasswordPage' });
    }

    goToInvite() {
        this.isShowMenuMobile = false;
        this.$router.push({ name: 'InviteInfoPage.vue' });
    }

    async logOut() {
        await this.$store.dispatch('setLoadingIndicator', true, { root: true });
        const response = await this.$store.dispatch('auth/logOut');
        await this.$store.dispatch('setLoadingIndicator', false, { root: true });
        if (response.success) {
            this.$router.push({ name: 'LoginPage' });
            this.disconnectWallet();
            location.reload();
        }
    }

    changeToLink(menu) {
        if (menu.redirectLink) {
            window.open(menu.redirectLink, '_blank').focus();
        } else {
            this.isShowMenuMobile = false;
            this.$router.push(menu.path);
        }
    }

    get loginSuccess() {
        return this.$store.state.auth.loginSuccess;
    }

    get userLogined() {
        return this.$store?.state?.auth?.userLogined;
    }

    login() {
        this.$router.push({ name: 'LoginPage' });
    }

    register() {
        this.$router.push({ name: 'RegisterPage' });
    }

    showMenuMobile() {
        this.isShowMenuMobile = !this.isShowMenuMobile;
    }

    setCookie(name, value, days = 7) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    get desktopDevice() {
        return this.isDesktop;
    }

    get typeDevice() {
        const deviceDetector = new DeviceDetector();
        const userAgent = navigator.userAgent;
        const device = deviceDetector.parse(userAgent);
        let deviceName = device.device ? device.device.type : '';
        if (!deviceName && device?.os?.name === 'iOS') {
            deviceName = 'smartphone';
        }
        return deviceName;
    }

    directTransaction() {
        if (this.$router.currentRoute?.name !== 'TransactionHistory') {
            this.isShowMenuMobile = false;
            this.$router.push({ name: 'TransactionHistory' });
        }
    }
}
</script>
<style lang="scss">
@import '@/sass/variable.scss';

.header_main {
    display: flex;
    height: 100%;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.button__auth {
    @apply mobile:w-full tablet:w-full w-fit border-2 border-primary hover:text-white h-12 rounded-3xl hover:bg-primary flex cursor-pointer px-6 py-2 items-center justify-center text-primary font-bold;
}

.v-list-item__title {
    display: flex;
    align-items: center;
    color: $blue_2;
    font-size: 16px;
    cursor: pointer;

    .icon {
        color: $blue_2;
        margin-right: 15px;
    }
}
</style>
